import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import * as React from 'react';
import MainSidebar from '../MainSideMenu/MainSidebar';
import './index.css';

export default function DrawerMenuOptions() {
    const [open, setOpen] = React.useState(false);

    const toggleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button
                onClick={() => setOpen(true)}
                style={{ outline: 'none', boxShadow: 'none' }} // Remove o foco visual
            >
                <i className="bi bi-list" style={{ fontSize: "28px", color: 'white' }}></i>
            </Button>

            <Drawer
                open={open} onClose={() => toggleDrawerClose()}
                anchor="left"
                PaperProps={{
                    sx: { width: '280px' }
                }}
            >
                <MainSidebar
                    toggleDrawerClose={toggleDrawerClose}
                />
            </Drawer>
        </div >
    );
}
